import { render } from "./Hotspot4.vue?vue&type=template&id=0eb6a19f&scoped=true&ts=true"
import script from "./Hotspot4.vue?vue&type=script&lang=ts"
export * from "./Hotspot4.vue?vue&type=script&lang=ts"

import "./Hotspot4.vue?vue&type=style&index=0&id=0eb6a19f&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb6a19f"]])

export default __exports__